import type { MessagesQueryParamsApi } from './useMessagesQuery';

export const messagingQueryKeys = {
  all: ['messaging'] as const,
  threads: () => [...messagingQueryKeys.all, 'threads'] as const,
  threadList: (filters: Record<string, unknown>) =>
    [...messagingQueryKeys.threads(), 'list', filters] as const,
  thread: (threadId: string | null) =>
    [...messagingQueryKeys.threads(), threadId] as const,
  threadMessages: (
    threadId: string,
    statuses?: MessagesQueryParamsApi['statuses'],
  ) =>
    statuses
      ? [...messagingQueryKeys.thread(threadId), 'messages', statuses]
      : [...messagingQueryKeys.thread(threadId), 'messages'],
  threadMessage: (threadId: string, messageId: string) =>
    [...messagingQueryKeys.threadMessages(threadId), messageId] as const,
  // A job scope is appended last, so invalidating `messages(statuses)` also
  // refreshes every job-scoped list with those statuses.
  messages: (
    statuses?: MessagesQueryParamsApi['statuses'],
    jobId?: MessagesQueryParamsApi['jobId'],
  ) => {
    const key = statuses
      ? [...messagingQueryKeys.all, 'messages', statuses]
      : [...messagingQueryKeys.all, 'messages'];
    return jobId ? [...key, jobId] : key;
  },
};
